import { useEffect, useState } from "react";
import { BookOpen, Download } from "lucide-react";
import { Container, Eyebrow, Section, Reveal } from "./common";
import { api, API } from "../lib/api";

export const BibliotecaPDF = () => {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    api.get("/library").then((r) => setDocs(r.data)).catch(() => {});
  }, []);

  const resolveUrl = (d) => (d.is_external ? d.url : `${API}${d.url.replace("/api", "")}`);

  return (
    <Section id="biblioteca">
      <Container>
        <Reveal>
          <Eyebrow>Documentos · Marco intelectual</Eyebrow>
          <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
            Biblioteca <span className="text-rc-sage italic">Raíz Commerce</span>
          </h2>
          <p className="mt-6 max-w-3xl text-stone-400 font-light leading-relaxed">
            La metodología completa, su origen histórico, su contraste internacional, el Plan Maestro del café
            y el Atlas técnico del territorio — abiertos para leer y descargar. El pensamiento detrás del
            Método NODO, disponible para consulta.
          </p>
        </Reveal>

        <div className="mt-14 space-y-5">
          {docs.map((d, i) => {
            const url = resolveUrl(d);
            return (
              <Reveal key={d.id} delay={(i % 3) * 0.06}>
                <div className="group flex flex-col lg:flex-row lg:items-center gap-6 p-7 md:p-8 rounded-2xl bg-rc-card border border-rc-border hover:border-rc-sage/40 transition-all duration-300">
                  <div className="flex-1">
                    <div className="text-xs font-mono text-rc-sage uppercase tracking-wider">{d.tag}</div>
                    <h3 className="mt-2 font-serif text-2xl text-stone-100">{d.title}</h3>
                    <p className="mt-3 text-sm text-stone-400 font-light leading-relaxed max-w-2xl">{d.text}</p>
                    <div className="mt-3 text-xs font-mono text-stone-600">{d.meta}</div>
                  </div>
                  <div className="flex gap-3 shrink-0">
                    <a href={url} target="_blank" rel="noopener noreferrer"
                      data-testid={`biblioteca-leer-${i}`}
                      className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-rc-forest hover:bg-rc-forestlight text-stone-100 text-sm transition-colors">
                      <BookOpen className="w-4 h-4" /> Leer aquí
                    </a>
                    <a href={url} download
                      data-testid={`biblioteca-descargar-${i}`}
                      className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-rc-border hover:border-rc-sage/50 text-stone-200 text-sm transition-colors">
                      <Download className="w-4 h-4" /> Descargar
                    </a>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </Section>
  );
};
